<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/d8fW49/tc-custom/9781631683718.jpg?1705205291893" alt="This image is the cover for the book Green Hero"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Green Hero
      </h1>
      <p class="bookDescription body article font2">
        <p>Finn McCool was born a giant with the gift of Celtic wit but—at least in his youth—is prone to bad luck. One day McCool will become the chieftain of Fianna hunter-warriors, and the greatest Irish folk hero of all time. But until then, he has some growing up to do.<br/><br/> In <i>The Green Hero</i>, renowned mythologist Bernard Evslin recounts the tales of Finn McCool’s early years: his attempts to woo Murtha, the girl he fell in love with when he was just three days old; his torment by the Fish-hag; his struggles with the whims of the goddess Amara; and more. This amusing collection retells the early exploits of a man who became a legend.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bernard Evslin
      </h2>
      
      <p class="authorDescription body article">Bernard Evslin (1922&ndash;1993) was a bestselling and award-winning author known for his works on Greek and other cultural mythologies. The <i>New York Times</i> called him &ldquo;one of the most widely published authors of classical mythology in the world.&rdquo; He was born in New Rochelle, New York, and attended Rutgers University. After several years working as a playwright, screenwriter, and documentary producer, he began publishing novels and short stories in the late 1960s. During his long career, Evslin published more than seventy books&mdash;over thirty of which were for young adults. His bestseller <i>Heroes, Gods and Monsters of the Greek Myths</i> has been translated into ten different languages and has sold more than ten million copies worldwide. He won the National Education Association Award in 1961, and in 1986 his book <i>Hercules</i> received the Washington Irving Children&rsquo;s Book Choice Award. Evslin died in Kauai, Hawaii, at the age of seventy-seven.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6fad7a84